<template>
    <div>
      <commonIndex :tjType="3"/>
    </div>
</template>
           
<script>
import commonIndex from '../commonIndex.vue'
export default {
  components:{
    commonIndex
  }           
}
</script>
<style scoped>
            
</style>